<template>
  <v-app id="app">
    <div v-if="isReady && layout">
      <NewUpdates />
      <component :is="layout" v-if="layout" />
      <!-- Notification dialog - temporarily disabled due to scroll issues -->
      <!--
      <v-dialog
        v-model="showInfo"
        persistent
        max-width="550"
        transition="dialog-bottom-transition"
        :scrollable="false"
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: white;
            padding: 20px;
            flex-direction: column;
          "
        >
          <div style="width: 100%; display: flex; justify-content: flex-end">
            <v-btn color="primary" icon @click="showInfo = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-icon style="margin-top: -40px" size="50" color="primary"
            >mdi-information</v-icon
          >
          <h2 style="margin-top: 10px; text-align: center">
            {{ this.$store.getters.appInfo.title }}
          </h2>
          <p style="margin-top: 10px; text-align: center">
            {{ this.$store.getters.appInfo.description }}
          </p>
        </div>
      </v-dialog>
      -->
    </div>
  </v-app>
</template>

<script>
/*
Actions:
  Load API Layout
  Change colors
  Load template layout
  Load translations
  Reload tabs change:
    storeInfo
    loacale
*/
import Admin from "@/layouts/admin/Index.vue";
import Public from "@/layouts/public/Public.vue";
import Account from "@/layouts/admin/Account.vue";
import Customer from "@/layouts/customer/Customer.vue";
import Default from "@/layouts/Default.vue";
import { loadMessages } from "@/plugins/i18n";
export default {
  name: "App",
  data: () => ({
    isReady: false,
    layout: null,
    showInfo: false,
    // scrollRestoreInterval: null,
    // scrollObserver: null,
  }),

  watch: {
    // showInfo: function (newVal) {
    //   // Scroll protection - temporarily disabled
    // },
    "$store.getters.appInfo": function () {
      this.changeColors(this.$store.getters.appInfo);
      this.isReady = true;
      // Notification dialog - temporarily disabled due to scroll issues
      // if (
      //   this.$store.getters.appInfo.title &&
      //   this.$store.getters.appInfo.description
      // ) {
      //   const name = this.$route.name;
      //   if (name === "Home" || name === "Discovery") {
      //     this.showInfo = true;
      //   }
      // }
      if (this.$store.getters.appInfo.favicon) {
        let favicon = document.querySelector('link[rel="icon"]');
        if (!favicon) {
          favicon = document.createElement("link");
          favicon.setAttribute("rel", "icon");
          favicon.setAttribute("type", "image/png");
          document.head.appendChild(favicon);
        }
        favicon.setAttribute("href", this.$store.getters.appInfo.favicon);
      }
    },
    "$store.getters.storeInfo": function () {
      if (this.$store.getters.storeInfo) {
        this.$appPageTitle.tab(this.$route.name);
      }
    },
    "$store.getters.locale": function () {
      setTimeout(() => {
        this.$appPageTitle.tab(this.$route.name);
      }, 100);
    },
    "$store.getters.appLayout": function (newLayout) {
      if (newLayout) {
        this.setLayout(newLayout);
      }
    },
  },
  async beforeMount() {
    this.$store.dispatch("app/loadAppInfo");
    let favicon = document.querySelector('link[rel="icon"]');
    if (!favicon) {
      favicon = document.createElement("link");
      favicon.setAttribute("rel", "icon");
      favicon.setAttribute("type", "image/png");
      document.head.appendChild(favicon);
    }
    favicon.setAttribute(
      "href",
      "https://orderapp-tenants-images.s3.eu-central-1.amazonaws.com/images/App/favicon.ico"
    );
  },
  created() {
    loadMessages(this.$store.getters.locale);
    // Scroll protection - temporarily disabled
    // this.setupScrollProtection();
  },
  // beforeDestroy() {
  //   // Scroll protection cleanup - temporarily disabled
  // },

  methods: {
    setLayout: function (layout) {
      switch (layout) {
        case "Public":
          this.layout = Public;
          break;
        case "Account":
          this.layout = Account;
          break;
        case "Admin":
          this.layout = Admin;
          break;
        case "Customer":
          this.layout = Customer;
          break;
        default:
          this.layout = Default;
          break;
      }
      window.scrollTo(0, 0);
    },
    changeColors: async function () {
      const self = this;
      let colors = new Form(self.$vuetify.theme.themes.light);
      colors.keys().forEach((key) => {
        if (self.$store.getters.appInfo[key]) {
          self.$vuetify.theme.themes.light[key] =
            self.$store.getters.appInfo[key];
          self.$vuetify.theme.themes.dark[key] =
            self.$store.getters.appInfo[key];
        }
      });
    },
    // handleDialogChange: function (value) {
    //   // Scroll protection - temporarily disabled
    // },
    // setupScrollProtection: function () {
    //   // Scroll protection - temporarily disabled
    // },
  },
};
</script>
